import CustomStore from 'devextreme/data/custom_store'
import DataSource from 'devextreme/data/data_source'

import DataGrid, {
  Column,
  ColumnFixing,
  GroupItem,
  Grouping,
  HeaderFilter,
  type IColumnFixingProps,
  type IColumnProps,
  type IDataGridOptions,
  type IGroupItemProps,
  type IGroupingProps,
  type IGroupPanelProps,
  type IHeaderFilterProps,
  type IMasterDetailProps,
  type IPagerProps,
  type IPagingProps,
  type IScrollingProps,
  type ISearchPanelProps,
  type ISortingProps,
  type IStateStoringProps,
  MasterDetail,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Sorting,
  StateStoring,
  Summary
} from 'devextreme-react/data-grid'
import { type ForwardedRef, forwardRef } from 'react'

export type MolsonDxGridProps = IDataGridOptions & {
  columnsProps?: IColumnProps[]
  headerFilterProps?: IHeaderFilterProps
  pagerProps?: IPagerProps
  pagingProps?: IPagingProps
  groupPanelProps?: IGroupPanelProps
  groupingProps?: IGroupingProps
  groupItemProps?: IGroupItemProps
  scrollingProps?: IScrollingProps
  sortingProps?: ISortingProps
  searchPanelProps?: ISearchPanelProps
  stateStoringProps?: IStateStoringProps
  columnFixingProps?: IColumnFixingProps
  masterDetailProps?: IMasterDetailProps
}

export const MolsonDxGrid = forwardRef(
  (
    {
      headerFilterProps = {
        visible: true,
        texts: {
          ok: 'Apply'
        }
      },
      columnsProps,
      pagerProps = {
        visible: true,
        allowedPageSizes: [10],
        showPageSizeSelector: false,
        displayMode: 'full',
        showInfo: false,
        showNavigationButtons: true
      },
      pagingProps = {
        enabled: true,
        defaultPageSize: 10
      },
      groupingProps = {
        autoExpandAll: false
      },
      groupItemProps,
      scrollingProps,
      sortingProps,
      searchPanelProps,
      stateStoringProps,
      columnFixingProps,
      masterDetailProps,
      showColumnLines = true,
      showRowLines = true,
      filterRow = {
        visible: true
      },
      ...props
    }: MolsonDxGridProps,
    ref: ForwardedRef<DataGrid>
  ) => {
    return (
      <DataGrid
        ref={ref}
        showColumnLines={showColumnLines}
        showRowLines={showRowLines}
        filterRow={filterRow}
        {...props}
        onEditorPreparing={e => {
          if (e.parentType === 'searchPanel') {
            e.editorOptions.stylingMode = 'outlined'
          }
        }}
      >
        {searchPanelProps && <SearchPanel {...searchPanelProps} />}
        {stateStoringProps && <StateStoring {...stateStoringProps} />}
        {columnFixingProps && <ColumnFixing {...columnFixingProps} />}
        {headerFilterProps && <HeaderFilter {...headerFilterProps} />}
        {columnsProps?.map((columnProps, index) => {
          return (
            <Column
              {...columnProps}
              key={`${columnProps.caption}-${0.1 * index}`}
            />
          )
        })}
        {groupingProps && <Grouping {...groupingProps} />}
        {pagerProps && <Pager {...pagerProps} />}
        {pagingProps && <Paging {...pagingProps} />}
        {sortingProps && <Sorting {...sortingProps} />}
        {scrollingProps && <Scrolling {...scrollingProps} />}
        {groupItemProps && (
          <Summary>
            <GroupItem {...groupItemProps} />
          </Summary>
        )}

        {masterDetailProps && <MasterDetail {...masterDetailProps} />}
      </DataGrid>
    )
  }
)

export type { ColumnCellTemplateData } from 'devextreme/ui/data_grid'
export { createStore } from 'devextreme-aspnet-data-nojquery'
export { CustomStore, DataSource }
